import { SVG } from '../svg';
import { IconProps } from '../types';

export function CheckIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="M20 6 9 17l-5-5" />
    </SVG>
  );
}
